export default __webpack_public_path__ + "static/media/cloudy.177821c5.png";